import { createFileRoute } from '@tanstack/react-router';
import { userStaticData } from '../user';

export const Route = createFileRoute('/_private-routes/user/linked')({
  staticData: userStaticData
});
